import { AlertCircle } from 'lucide-react';

// props
interface FormErrorProps {
    message?: string;
}

// componente de error
export function FormError({ message }: FormErrorProps) {
    if (!message) return null;

    return (
        <p className="flex items-center gap-1.5 mt-1.5 text-xs font-medium text-red-500">
            <AlertCircle className="h-3.5 w-3.5 shrink-0" />
            <span>{message}</span>
        </p>
    );
}